import campaignsApi from 'common/src/modules/campaigns/campaigns.api';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {CampaignSetupAgentToolName} from '../../../../campaignSetupAgent.enums';

// Tool schema
const getAvailableSignalsToolSchema = z.object({
  signalName: z.string().describe('The signal name to search for'),
});

function getContentSignalsTool(store: CLStore) {
  async function execute({
    input: {signalName},
  }: ToolExecuteParams<typeof getAvailableSignalsToolSchema>): Promise<ToolResult> {
    const {campaign, versionId} = store.getState().campaignPage.campaignTree;

    if (!campaign) {
      return toolError('Campaign is required to get content signals');
    }

    if (!versionId) {
      return toolError('Version ID is required to get content signals');
    }

    try {
      const signals = await campaignsApi.getSignalsByNameForContentCard({
        signalName,
        campaignId: campaign.id,
        versionId,
      });

      const signalsMetadata = signals.map((signal) => ({
        signalKey: signal.value,
        signalName: signal.name,
        category: signal.category,
      }));

      return toolResult(
        JSON.stringify({
          signals: signalsMetadata,
          instructions:
            signalsMetadata.length > 0
              ? `Multiple signals found, ask the user for clarification.`
              : '',
        }),
      );
    } catch (error) {
      return toolError(
        `Error retrieving available signals: ${
          error instanceof Error ? error.message : 'Unknown error'
        }`,
      );
    }
  }

  return tool({
    name: CampaignSetupAgentToolName.GetContentSignals,
    displayName: 'Getting available signals',
    description: 'Retrieve available signals for matching strategy configuration in content card',
    execute,
    inputSchema: getAvailableSignalsToolSchema,
  });
}

export default getContentSignalsTool;
